import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AiProcessExecutionStatus } from 'constants/aiProcessRuns';

import { AiActivityTestIds } from '../../../AiActivity.testIds';
import { formatRunProgressLabel } from '../../../AiActivity.utils';

import { STATUS_TO_FILL_PALETTE } from './RunProgressMeter.constants';
import { getFillStyles, labelRowStyles, meterStyles, trackStyles } from './RunProgressMeter.styles';

const RunProgressMeter = ({
  status,
  total,
  completed,
  ratio,
  runningCount = 0,
  isNeedsInput = false,
}) => {
  const fillPalette = STATUS_TO_FILL_PALETTE[status] ?? null;

  return (
    <Box data-testid={AiActivityTestIds.RUN_PROGRESS_METER} sx={meterStyles}>
      <Box sx={labelRowStyles}>
        <Typography variant="regular12">Overall progress</Typography>
        <Typography variant="medium12">
          {formatRunProgressLabel({ completed, total, runningCount, isNeedsInput })}
        </Typography>
      </Box>
      <Box sx={trackStyles}>
        <Box sx={getFillStyles({ ratio, fillPalette })} />
      </Box>
    </Box>
  );
};

RunProgressMeter.propTypes = {
  total: PropTypes.number.isRequired,
  completed: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
  isNeedsInput: PropTypes.bool,
  runningCount: PropTypes.number,
  status: PropTypes.oneOf(Object.values(AiProcessExecutionStatus)),
};

export default memo(RunProgressMeter);
